import { getApiUrl } from '../../config/runtime.config'

interface EndpointConfig {
  url: string | ((...args: any[]) => string)
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
}

export const apiConfig = {
  baseUrl: getApiUrl,
  endpoints: {
    auth: {
      me: { url: '/auth/me', method: 'GET' } satisfies EndpointConfig,
      login: { url: '/auth/login', method: 'POST' } satisfies EndpointConfig,
      logout: { url: '/auth/logout', method: 'POST' } satisfies EndpointConfig,
      google: { url: '/auth/google', method: 'GET' } satisfies EndpointConfig,
      users: { url: '/admin/auth-users', method: 'GET' } satisfies EndpointConfig,
      createUser: { url: '/admin/auth-users', method: 'POST' } satisfies EndpointConfig,
      updateUser: { url: (email: string) => `/admin/auth-users/${encodeURIComponent(email)}`, method: 'PUT' } satisfies EndpointConfig,
      deleteUser: { url: (email: string) => `/admin/auth-users/${encodeURIComponent(email)}`, method: 'DELETE' } satisfies EndpointConfig,
    },
    apiKeys: {
      list: { url: '/admin/api-keys', method: 'GET' } satisfies EndpointConfig,
      create: { url: '/admin/api-keys', method: 'POST' } satisfies EndpointConfig,
      update: { url: (id: number) => `/admin/api-keys/${id}`, method: 'PUT' } satisfies EndpointConfig,
      delete: { url: (id: number) => `/admin/api-keys/${id}`, method: 'DELETE' } satisfies EndpointConfig,
      topUp: { url: (id: number) => `/admin/api-keys/${id}/top-up`, method: 'POST' } satisfies EndpointConfig,
      transactions: { url: (id: number) => `/admin/api-keys/${id}/transactions`, method: 'GET' } satisfies EndpointConfig,
      retryInsufficient: { url: (id: number) => `/admin/api-keys/${id}/retry-insufficient-balance`, method: 'POST' } satisfies EndpointConfig,
    },
    emails: {
      list: { url: '/admin/emails', method: 'GET' } satisfies EndpointConfig,
      export: { url: '/admin/emails/export.csv', method: 'GET' } satisfies EndpointConfig,
      details: { url: (id: number) => `/admin/emails/${id}`, method: 'GET' } satisfies EndpointConfig,
      summary: { url: '/admin/emails/summary', method: 'GET' } satisfies EndpointConfig,
      retry: { url: (id: number) => `/admin/emails/${id}/retry`, method: 'POST' } satisfies EndpointConfig,
    },
    billing: {
      tariff: { url: '/admin/billing/tariff', method: 'GET' } satisfies EndpointConfig,
      updateTariff: { url: '/admin/billing/tariff', method: 'PUT' } satisfies EndpointConfig,
    },
  },
}
